import React from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form, Button,
  Input,
} from 'antd'
import history from 'utils/history'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import Helper from 'utils/Helper'

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 5,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
}

const tailLayout = {
  wrapperCol: {
    xs: {
      offset: 24,
      span: 24,
    },
    sm: {
      offset: 5,
      span: 12,
    },
  },
}

const FormGoverment = ({
  handleSubmit, isEdit, isSubmit,
}) => (
  <div>
    <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
      <h3 className="title-content mb-0">
        {isEdit ? 'Edit' : 'Add'}
        {' '}
        Bantuan
      </h3>
    </div>
    <Card className="pt-4">
      <Form
        {...formItemLayout}
        name="survey"
        onFinish={handleSubmit}
      >
        <Form.Item label="Judul" name="title" rules={[{ required: true }]}>
          <Input placeholder="Judul" />
        </Form.Item>

        <Form.Item label="URL" name="url" rules={[{ required: false }]}>
          <Input placeholder="url (jika diperlukan)" />
        </Form.Item>

        <Form.Item
          label="Konten"
        >
          <CKEditor
            name="content"
            editor={ ClassicEditor }
            data=""
            onReady={(editor) => {
              editor.editing.view.change((writer) => {
              writer.setStyle(
                  "height",
                  "200px",
                  editor.editing.view.document.getRoot()
              );
              });
            }}
          />
          <CKEditor
            name="content"
            data=""
            config={{
              extraPlugins: 'justify,font,colorbutton',
              toolbarGroups: [
                { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                { name: 'links' },
                {
                  name: 'paragraph',
                  groups: ['list', 'indent', 'blocks', 'align', 'bidi'], // 'align' -> 'justify' plugin
                },
              ],
            }}
          />
        </Form.Item>

        <Form.Item {...tailLayout} className="btn-primary-wrapper text-right">
          <Button onClick={() => window.history.back()} className="m-r-10" style={{ display: 'inline-block' }}>Cancel</Button>
          <Button type="primary" loading={isSubmit} htmlType="submit">{isEdit ? 'Submit Change' : 'Create'}</Button>
        </Form.Item>
      </Form>
    </Card>
  </div>
)

FormGoverment.propTypes = {
  handleSubmit: PropTypes.func,
  isSubmit: PropTypes.bool,
  isEdit: PropTypes.bool,
}

export default FormGoverment
